module.exports = __webpack_public_path__ + "img/mountains.0a5cfceb.jpg";